// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__12qrs","error":"Textarea_error__1HGRv","readonly":"Textarea_readonly__3ayVb","disabled":"Textarea_disabled__6hrNc"};